import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { Permission, RoleResponse, useLazyGetRoleByIdQuery } from "../../services/accessRole";
import moment from "moment";
import { showError } from "../../constants/toasts";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../utils/enums";

const RoleDetail = () => {

  const navigate = useNavigate();
  const params = useParams()
  const id = params.id as string
  const [loading,setLoading] = useState(false)
  const user = useAuth()
  const [role,setRole] = useState<RoleResponse>( {
    _id: '' ,
    name: '',
    permission:[],
    isDeleted: false,
    isBlocked: false,
    createdAt: '',
    updatedAt: '',
    __v: 0
})

  const rows:Permission[]= role?.permission as Permission[];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "label",
      headerName: "Module Name",
      editable: false,
      sortable: false
    },
    {
      flex: 1,
      minWidth: 180,
      field: "isView",
      headerName: "View",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    },
    {
      flex: 1,
      minWidth: 180,
      field: "isAdd",
      headerName: "Add/Edit",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    },
    // {
    //   flex: 1,
    //   minWidth: 150,
    //   field: "edit",
    //   headerName: "Edit",
    //   editable: false,
    //   sortable: false,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: () => {
    //     return (
    //       <DoneIcon className="c_success" />
    //     )
    //   }
    // },
    {
      flex: 1,
      minWidth: 100,
      field: "isDelete",
      headerName: "Delete",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        params.value ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />
      )
    }
  ];
  
  let hidden = ["fullName"];


   const [getRoleById] = useLazyGetRoleByIdQuery();
  
    const getRole = async () => {
      setLoading(true);
      try {
        const response = await getRoleById({
          id,
        }).unwrap();
        setLoading(false);
  
        if (response?.statusCode === 200) {
          setRole(response?.data)
          // setCustomerDetail(response?.data || null);
          // setSubAdmin(response?.data)
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        setLoading(false);
      }
    };

    

  useEffect(()=>{
    if(user?.role===ROLES.SUB_ADMIN){
      navigate('/permission-denied',{replace:true})
    }
  },[user])

  
    useEffect(()=>{
      if(id) getRole()
    },[id])

  

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</span>
          {' '} - Role Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{role?.name}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{moment(role?.createdAt).format('YYYY-MM-DD')}</p>
          </div>
        </div>
       {rows.length > 0 && <div className="sorting_table mt_20 subadmin">
          <TableComponent
            columns={columns}
            rows={rows}
          />
        </div>}
      </div>
    </MainContainer>
  );
};

export default RoleDetail;
